var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 84,
    viewBox: "0 0 106 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 0.75C12.8995 0.75 8.60725 2.5279 5.44257 5.69257C2.2779 8.85725 0.5 13.1495 0.5 17.625V23.25H105.5V17.625C105.5 13.1495 103.722 8.85725 100.557 5.69257C97.3927 2.5279 93.1005 0.75 88.625 0.75H17.375ZM0.5 66.375V30.75H105.5V66.375C105.5 70.8505 103.722 75.1427 100.557 78.3074C97.3927 81.4721 93.1005 83.25 88.625 83.25H17.375C12.8995 83.25 8.60725 81.4721 5.44257 78.3074C2.2779 75.1427 0.5 70.8505 0.5 66.375ZM71.75 53.25C70.7554 53.25 69.8016 53.6451 69.0983 54.3483C68.3951 55.0516 68 56.0054 68 57C68 57.9946 68.3951 58.9484 69.0983 59.6517C69.8016 60.3549 70.7554 60.75 71.75 60.75H83C83.9946 60.75 84.9484 60.3549 85.6517 59.6517C86.3549 58.9484 86.75 57.9946 86.75 57C86.75 56.0054 86.3549 55.0516 85.6517 54.3483C84.9484 53.6451 83.9946 53.25 83 53.25H71.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletImageIcon);
export default __webpack_public_path__ + "static/media/walletImageIcon.7e7684b5b2f378ad1a9273724f2c6421.svg";
export { ForwardRef as ReactComponent };